import { render, staticRenderFns } from "./fixedTime.vue?vue&type=template&id=47b7df80&scoped=true&"
import script from "./fixedTime.vue?vue&type=script&lang=js&"
export * from "./fixedTime.vue?vue&type=script&lang=js&"
import style0 from "./fixedTime.vue?vue&type=style&index=0&id=47b7df80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7df80",
  null
  
)

export default component.exports